const normalizeIdentifier = (value?: string | null) => {
    if (typeof value !== 'string') {
        return undefined;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : undefined;
};

export const resolveCollectionIdentifier = (componentMeta?: any, fallbackSlug?: string) => {
    const fallback = normalizeIdentifier(fallbackSlug);
    if (!componentMeta) {
        return fallback;
    }

    const mongoName = normalizeIdentifier(componentMeta.mongoCollection);
    const collectionName = normalizeIdentifier(componentMeta.collection);
    const slugName = normalizeIdentifier(componentMeta.slug);

    // Filter out "default_collection" as it's not a valid collection name
    const isValidCollection = (name: string | undefined) => {
        return name && name !== 'default_collection';
    };

    return isValidCollection(mongoName) ? mongoName :
        (isValidCollection(collectionName) ? collectionName :
            (slugName || fallback));
};

/**
 * Returns the MongoDB collection name for use as the file upload folder.
 * Prefers mongoCollection so uploads are stored under the actual Mongo collection name.
 */
export const getMongoCollectionNameForFolder = (componentMeta?: any, fallbackSlug?: string): string | undefined => {
    const mongoName = normalizeIdentifier(componentMeta?.mongoCollection);
    if (mongoName && mongoName !== 'default_collection') {
        return mongoName;
    }
    return resolveCollectionIdentifier(componentMeta, fallbackSlug) || undefined;
};

/**
 * Actual MongoDB collection name for admin inspector links. Uses `mongoCollection`, then `collection`,
 * then `slug` from component meta only — never the route slug.
 */
export function mongoCollectionNameForInspector(componentMeta?: any): string | undefined {
    return getMongoCollectionNameForFolder(componentMeta, undefined);
}

/** Admin Mongo inspector: select collection and apply find filter (e.g. `{ uid }`). */
export function buildAdminMongoDocumentUrl(collectionName: string, uid: string): string {
    const filter = JSON.stringify({ uid: String(uid).trim() });
    return `/admin/mongo?collection=${encodeURIComponent(collectionName)}&filter=${encodeURIComponent(filter)}`;
}

